//External
import React, { useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import ReactHtmlParser from "react-html-parser";

/*******************
  @Purpose : used for features
  @Parameter : {features}
  @Author : INIC
  *******************/
function Homefaqs({ faqs }) {
  const [activeId, setActiveId] = useState(0);

  function toggleActive(id) {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  }

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      {/* Accordion design start */}
      <section className="home-accordian py-75 pb-0">
        <div className="custom-container">
          <div className="section-heading">
            <h3 className="mb-0">Most Common Questions</h3>
          </div>

          <Accordion defaultActiveKey={0} className="custom-accordion">
            {faqs.map((row, index) => (
              <div className="accordion-item" key={index}>
                <Accordion.Toggle
                  onClick={() => toggleActive(index + 1)}
                  as={Card.Header}
                  eventKey={index + 1}
                  className="d-flex align-items-center justify-content-between border-0"
                >
                  <h4 className="mb-0">{row?.title}</h4>
                  <span
                    className={
                      activeId === index + 1
                        ? "icon icon-down-caret active"
                        : "icon icon-down-caret"
                    }
                  ></span>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={index + 1}>
                  <Card.Body>
                    <pre>{ReactHtmlParser(row?.description)}</pre>
                  </Card.Body>
                </Accordion.Collapse>
              </div>
            ))}
          </Accordion>
        </div>
      </section>
      {/* Accordion design end */}
    </>
  );
}

export default Homefaqs;
